<div class="control-line mat-elevation-z8">
  <div class="filter-actions-line"
    style="box-shadow: none !important; background-color: rgba(255, 255, 255, 0.8) !important; ">
    <app-select-search (selectedItemId)="onStatusReceived($event)" [selectItems]="statusInfo" selectTitle="Status">        
    </app-select-search>
    <app-select-search (selectedItemId)="onCustomerReceived($event)" [selectItems]="selectCustomerItems"
      selectTitle="Customer"></app-select-search>
    <app-select-search (selectedItemId)="onStreamReceived($event)" [selectItems]="selectStreamItems"
      selectTitle="Stream"></app-select-search>

    <!-- months-select.component.html -->
    <mat-form-field appearance="outline">
      <mat-label>Month</mat-label>
      <mat-select id="selectMonth" data-testid="selectMonth" [(ngModel)]="selectedMonth">
        <mat-option *ngFor="let m of months" [value]="m.value">
          {{ m.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Year</mat-label>
      <mat-select [(ngModel)]="selectedYear" id="selectYear" data-testid="selectYear">
        <mat-option *ngFor="let y of years" [value]="y">
          {{ y }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button id="toteinvbtn" data-testid="toteinvbtn" mat-raised-button color="primary" (click)="toteInvoiceSearch()">
      Search
    </button>
  </div>
</div>

<div class="gridheight mat-elevation-z8 viewport table-container">
  <table mat-table [dataSource]="dataSource" class=" viewport" matSort>
    <!-- Work Order Number Column -->
    <ng-container matColumnDef="workOrderNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Work Order Number </th>
      <td mat-cell *matCellDef="let element"> {{element.workOrderNumber}} </td>
    </ng-container>
    <!-- Reprocess Column -->
    <ng-container matColumnDef="response">
      <th mat-header-cell *matHeaderCellDef> Message/Transaction # </th>
      <td mat-cell *matCellDef="let element">
        {{element.response}}
      </td>
    </ng-container>

    <!-- Status Code Column -->
    <ng-container matColumnDef="statusCode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
      <td mat-cell *matCellDef="let element"> {{element.statusCode}} </td>
    </ng-container>

    <!-- Request Payload Column -->
    <ng-container matColumnDef="request">
      <th mat-header-cell *matHeaderCellDef> Request Payload </th>
      <td mat-cell *matCellDef="let element" class="request-cell">
        <button mat-raised-button color="warn" class="btn-payload" (click)="showPayloadRequest(element.request)">
          ...
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <!-- No Data Row -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length"
        style="color: red;text-align: center;font-weight: 500;">
        No Tote data available.
      </td>
    </tr>
  </table>

</div>